module.exports = __webpack_public_path__ + "static/media/DAB Widget.5f8e8be3.svg";